module.exports = __webpack_public_path__ + "assets/yuyanfanyi.36644316.svg";